import { defineMessage } from 'services/localization';

export const messages = {
    alwaysMandatory: defineMessage('always_mandatory'),
    alwaysOptional: defineMessage('always_optional'),
    readonly: defineMessage('readonly'),
    rename: defineMessage('rename'),
    remove: defineMessage('remove'),
    theFieldIsMandatory: defineMessage('the_field_is_mandatory'),
    theFieldIsOptional: defineMessage('the_field_is_optional'),
    theFieldIsReadonly: defineMessage('the_field_is_readonly'),
};
